/*
 * @Author: Teemo Ding
 * @Date: 2021-10-21 14:26:59
 * @LastEditTime: 2021-10-21 17:32:33
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/Components/UploadCodeVersion/index.tsx
 */

import { Input, ModalFooter } from '@/src/components/Antd';
import { Form } from 'antd';
import React, { Fragment } from 'react';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const UploadCodeVersion = ({
  onCancel,
  onUploadCodeVersion,
  miniProgramUuid,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    onUploadCodeVersion({ ...values, miniProgramUuid });
  };
  return (
    <Fragment>
      <div className={css.uploadCodeVersion}>
        <Form form={form} name='uploadCodeVersion' onFinish={onFinish}>
          <Form.Item
            name='version'
            labelCol={{ span: 24 }}
            label={getI18n(
              'salesChannelMiniProgramSettings.index.codeVersionNumber',
            )}
            rules={[
              {
                required: true,
                message: getI18n('general.moduleListError.999978'),
              },
            ]}>
            <Input maxLength={200} size='large' placeholder='1.0.0' />
          </Form.Item>
        </Form>
      </div>
      <ModalFooter
        okText={getI18n('salesChannelMiniProgramSettings.index.upload')}
        onOk={() => form.submit()}
        onCancel={onCancel}
      />
    </Fragment>
  );
};

export default UploadCodeVersion;
